'use client'

import { useTranslations } from 'next-intl'
import { useB2bContext } from '@/features/b2b/b2b-context'
import { CommonBanner } from '@/features/common/common-banner'
import { CommonPlacesSearch } from '@/features/common/common-places-search'

export const B2bBannerSearch = () => {
    const _t = useTranslations()
    const { onSelect } = useB2bContext()

    return (
        <CommonBanner tBaseKey="for-companies.banner">
            <CommonPlacesSearch
                onSelect={onSelect}
                tBaseKey={'for-companies'}
                inputClassName="md:min-w-[552px] w-full"
                containerClassName="justify-center"
            />
        </CommonBanner>
    )
}
